import axios from 'axios';

let prefix = "/system-currency"

const SystemCurrencyApi = {

	getSystemCurrencyList(payload){
		return axios.get( prefix + "/list", {params: payload})
	},
	updateSystemCurrency(payload){
		return axios.post( prefix + "/update", payload)
	},
	archiveSystemCurrency(payload){
		return axios.delete( prefix + "/delete", {params: payload})
	},
}

export default SystemCurrencyApi;
